import { render, staticRenderFns } from "./likeBtn.vue?vue&type=template&id=7c72ad74&scoped=true&"
import script from "./likeBtn.vue?vue&type=script&lang=js&"
export * from "./likeBtn.vue?vue&type=script&lang=js&"
import style0 from "./likeBtn.vue?vue&type=style&index=0&id=7c72ad74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c72ad74",
  null
  
)

export default component.exports